import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadParticipantsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadParticipantsQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | '_id' | 'id' | 'title' | 'department' | 'dateFrom' | 'dateTo'>
    & { orderIdDistribution: Types.Maybe<Array<(
      { __typename?: 'OrderIdDistribution' }
      & Pick<Types.OrderIdDistribution, 'orderId' | 'percentage' | 'annotation'>
    )>>, provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
    )>, createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, 'name'>
    ), participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'orderId' | 'dateTo' | 'dateFrom' | 'percentage' | 'nordschleife'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, '_id' | 'type' | 'name' | 'firstName' | 'lastName' | 'email'>
      )>, unknownPerson: Types.Maybe<(
        { __typename?: 'UnknownPerson' }
        & Pick<Types.UnknownPerson, 'isUnknown' | 'personType' | 'department' | 'supplier' | 'employee' | 'firstName' | 'surName'>
      )>, flight: Types.Maybe<(
        { __typename?: 'Flight' }
        & Pick<Types.Flight, 'flightType' | 'bookingStatus'>
      )>, accomodation: Types.Maybe<(
        { __typename?: 'Accomodation' }
        & Pick<Types.Accomodation, 'accomodationType' | 'dateFrom' | 'dateTo' | 'bookingStatus'>
        & { accomodation: Types.Maybe<(
          { __typename?: 'Lodging' }
          & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
        )> }
      )>, trackHotels: Types.Maybe<(
        { __typename?: 'TrackHotels' }
        & { outward: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
          )> }
        )>>, return: Types.Maybe<Array<(
          { __typename?: 'TrackHotel' }
          & Pick<Types.TrackHotel, 'dateFrom' | 'dateTo' | 'bookingStatus'>
          & { hotel: Types.Maybe<(
            { __typename?: 'Lodging' }
            & Pick<Types.Lodging, '_id' | 'title' | 'inactive'>
          )> }
        )>> }
      )>, rentalCar: Types.Maybe<(
        { __typename?: 'RentalCar' }
        & Pick<Types.RentalCar, 'dateTo' | 'dateFrom' | 'carType' | 'bookingStatus'>
      )>, ferry: Types.Maybe<(
        { __typename?: 'Ferry' }
        & Pick<Types.Ferry, 'dateTo' | 'timeTo' | 'dateFrom' | 'timeFrom' | 'bookingStatus'>
        & { outward: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title' | 'type' | 'origin' | 'destination'>
        )>, return: Types.Maybe<(
          { __typename?: 'FerryConnection' }
          & Pick<Types.FerryConnection, '_id' | 'title' | 'type' | 'origin' | 'destination'>
        )> }
      )> }
    )>> }
  )> }
);

export const ReadParticipantsDocument = gql`
    query ReadParticipants($search: String) {
  provings(filter: {title: {REGEX: $search}, status: {NIN: [8, 9, 10]}}) {
    _deleted
    _id
    id
    title
    department
    dateFrom
    dateTo
    orderIdDistribution {
      orderId
      percentage
      annotation
    }
    provingGround {
      _id
      title
      countryCode
    }
    createdBy {
      name
    }
    provingGround {
      _id
      title
      countryCode
    }
    participants {
      _id
      person {
        _id
        type
        name
        firstName
        lastName
        email
      }
      unknownPerson {
        isUnknown
        personType
        department
        supplier
        employee
        firstName
        surName
      }
      orderId
      dateTo
      dateFrom
      percentage
      flight {
        flightType
        bookingStatus
      }
      accomodation {
        accomodationType
        accomodation {
          _id
          title
          inactive
        }
        dateFrom
        dateTo
        bookingStatus
      }
      trackHotels {
        outward {
          dateFrom
          dateTo
          hotel {
            _id
            title
            inactive
          }
          bookingStatus
        }
        return {
          dateFrom
          dateTo
          hotel {
            _id
            title
            inactive
          }
          bookingStatus
        }
      }
      rentalCar {
        dateTo
        dateFrom
        carType
        bookingStatus
      }
      ferry {
        outward {
          _id
          title
          type
          origin
          destination
        }
        return {
          _id
          title
          type
          origin
          destination
        }
        dateTo
        timeTo
        dateFrom
        timeFrom
        bookingStatus
      }
      nordschleife
    }
  }
}
    `;

    export function useReadParticipantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadParticipantsQuery, ReadParticipantsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadParticipantsQuery, ReadParticipantsQueryVariables>(ReadParticipantsDocument, baseOptions);
    };
      export function useReadParticipantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadParticipantsQuery, ReadParticipantsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadParticipantsQuery, ReadParticipantsQueryVariables>(ReadParticipantsDocument, baseOptions);
      };
      
export type ReadParticipantsQueryHookResult = ReturnType<typeof useReadParticipantsQuery>;
export type ReadParticipantsQueryResult = ApolloReactCommon.QueryResult<ReadParticipantsQuery, ReadParticipantsQueryVariables>;